// @flow
import {translate} from 'react-i18next'
import {type HigherOrderComponent} from 'react-flow-types'

type TranslateFn = (keys: string | Array<string>, options?: Object) => string

export type WithTranslateProps = {t: TranslateFn}

type WithTranslate = () => HigherOrderComponent<{}, WithTranslateProps>

export default ((translate: any): WithTranslate)



// WEBPACK FOOTER //
// ./src/util/withTranslate.js